export const fetchArticles = resp => {
  return {
    type: "FETCH_ARTICLES",
    payload: resp
  };
};



// WEBPACK FOOTER //
// ./src/actions/actions/article.js